import React from 'react';
import { BrowserRouter as Router, Route, browserHistory, Switch, Redirect, HashRouter } from 'react-router-dom';
import $ from 'jquery';
import { Helmet } from 'react-helmet';
import Analytics from 'react-router-ga';

import { Dispatcher, Events, Actions } from './flux';

import {
  Home,
  QuemSomos,
  SobreRelatorio,
  // PlanoAcao,
  PlanoAcao2019,
  MensagemPresidencia,
  MensagemSuperintendencia,
  NotFound,
  Governanca,
  Diretoria,
  ConselhoFiscal,
  ConselhoEtica,
  ComiteExecutivo,
  OrganismosRepresentacao,
  Pessoas,
  Associados,
  Relacionamentos,
  NossoAno,
  ParaOMercado,
  AgendaRecursos,
  DentroDeCasa,
  Organograma,
  Iniciativas,
  Treinamentos,
  DataFundos,
  PerfilInvestidor,
  CursosEducativos,
  MercadoDeCapitais,
  AtuacaoInternacional,
  Selic40Anos,
  LeiLiberdadeEconomica,
  SupervisaoAtivos,
  CulturaDeDados,
  CertificacaoEducacao,
  BalancoOrientacoesPenalidades,
  Sumario,
  LinhaDoTempo,
  Eventos,
} from './views';

import { images, texts, settings, urls } from './settings/';
import { Header, Footer, Menu } from './components/';

import { TimelineMax, TweenMax } from 'gsap';

import './app.scss';

export default class App extends React.Component {
  constructor(props) {
    super(props);

    window.jQuery = $;
    window.$ = $;
    this.$ = $;
    global.jQuery = $;

    this.images = images;
    this.urls = urls;

    this.state = {
      menuOpened: false,

      error: false,
      errorText: '',

      success: false,
      successText: '',
      successTitle: '',
      successRedirect: '',

      width: window.innerWidth,
    };

    this.isAnimating = false;
    this.elmOverlay;
    this.overlay;

    this.globalDelay = settings.globalDelay;

    this.scrollTop = this.scrollTop.bind(this);
    this.animateTransition = this.animateTransition.bind(this);
    this.animateOverlay = this.animateOverlay.bind(this);
    this.scrollToMyRef = this.scrollToMyRef.bind(this);
    this.goToTop = this.goToTop.bind(this);

    this.bodyRef = React.createRef();
  }

  scrollTop(smooth = false) {
    if (smooth) {
      window.scrollTo({ top: this.bodyRef.current.offsetTop, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: this.bodyRef.current.offsetTop });
    }
  }

  scrollToMyRef = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  goToTop() {
    this.scrollToMyRef();
  }

  dAnimateTransition() {
    this.animateTransition();
  }

  showError(text, type, title) {
    console.log(text, type, title);
    this.setState({
      error: true,
      errorText: text,
      errorType: type,
      errorTitle: title,
    });
  }

  showSuccess(data) {
    this.setState({
      success: true,
      successText: data.text,
      successTitle: data.title,
      successRedirect: data.redirect ? data.redirect : '',
    });
  }

  dShowError(text) {
    this.showError(text);
  }

  dShowSuccess(data) {
    this.showSuccess(data);
  }

  dToggleMenu() {
    this.menuToggle();
  }

  componentWillMount() {
    Dispatcher.on(Events.GLOBAL_TRANSITION, this.dAnimateTransition.bind(this));
    Dispatcher.on(Events.SHOW_ERROR, this.dShowError.bind(this));
    Dispatcher.on(Events.SHOW_SUCCESS, this.dShowSuccess.bind(this));
    Dispatcher.on(Events.TOGGLE_MENU, this.dToggleMenu.bind(this));
  }

  componentDidMount() {
    this.timelineTransition = new TimelineMax();
  }

  componentDidUpdate() {}

  componentWillUnmount() {
    Dispatcher.removeListener(Events.GLOBAL_TRANSITION, this.dAnimateTransition);
    Dispatcher.removeListener(Events.SHOW_ERROR, this.dShowError);
    Dispatcher.removeListener(Events.SHOW_SUCCESS, this.dShowSuccess);
    Dispatcher.removeListener(Events.TOGGLE_MENU, this.dToggleMenu);
  }

  animateTransition() {
    this.animateOverlay();

    setTimeout(
      function() {
        this.scrollTop();
      }.bind(this),
      this.globalDelay
    );
  }

  animateOverlay() {
    // if (!this.overlay.isAnimating) {
    //   this.overlay.toggle();

    //   setTimeout(
    //     function() {
    //       this.overlay.toggle();
    //     }.bind(this),
    //     this.globalDelay
    //   );
    // }
    this.completeAnimation();
  }

  menuToggle() {
    const { menuOpened } = this.state;

    if (menuOpened) {
      this.animateOut();
      Actions.hideMenu();
      this.setState({ menuOpened: false });
    } else {
      this.animateIn();
      Actions.showMenu();
      this.setState({ menuOpened: true });
    }
  }

  completeAnimation() {
    this.animateInOut();
  }

  animateInOut() {
    this.timelineTransition.add(TweenMax.to(this.refs.layer1, 0.3, { x: '0%', delay: 0, ease: Power4.easeIn }));
    this.timelineTransition.add(TweenMax.to(this.refs.layer2, 0.5, { x: '0%', delay: 0.01, ease: Power4.easeIn }));

    this.timelineTransition.add(TweenMax.to(this.refs.layer2, 0.3, { x: '-100%', delay: 0.01, ease: Power4.easeOut }));
    this.timelineTransition.add(TweenMax.to(this.refs.layer1, 0.5, { x: '-100%', delay: 0.01, ease: Power4.easeOut }));

    // Voltando para a posição inicial
    this.timelineTransition.add(TweenMax.to(this.refs.layer1, 0, { x: '100%', delay: 0.2, ease: Power4.easeOut }));
    this.timelineTransition.add(TweenMax.to(this.refs.layer2, 0, { x: '100%', delay: 0.2, ease: Power4.easeOut }));
  }

  animateIn() {
    this.timelineTransition.add(TweenMax.to(this.refs.layer1, 0.5, { x: '0%', delay: 0, ease: Power4.easeIn }));
    this.timelineTransition.add(TweenMax.to(this.refs.layer2, 0.4, { x: '0%', delay: 0.01, ease: Power4.easeIn }));
  }

  animateOut() {
    this.timelineTransition.add(TweenMax.to(this.refs.layer2, 0.3, { x: '-100%', delay: 0.01, ease: Power4.easeOut }));
    this.timelineTransition.add(TweenMax.to(this.refs.layer1, 0.5, { x: '-100%', delay: 0.01, ease: Power4.easeOut }));

    // Voltando para a posição inicial
    this.timelineTransition.add(TweenMax.to(this.refs.layer1, 0, { x: '100%', delay: 0.2, ease: Power4.easeOut }));
    this.timelineTransition.add(TweenMax.to(this.refs.layer2, 0, { x: '100%', delay: 0.2, ease: Power4.easeOut }));
  }

  render = () => {
    const { menuOpened } = this.state;
    const transitionLayer = menuOpened ? ['transition_layer', 'transition_layer--active'] : ['transition_layer'];
    return (
      <HashRouter history={browserHistory}>
        <Analytics id={settings.gaId} /*debug*/>
          <div className="app" ref={this.bodyRef}>
            <Helmet>
              <title>{texts.title}</title>
              <meta name="title" content={texts.title} />
              <meta name="description" content={texts.description} />
            </Helmet>

            <div className={transitionLayer.join(' ')}>
              <div className="layer1" ref="layer1"></div>
              <div className="layer2" ref="layer2"></div>
              {/* <div className="layer3" ref="layer3"></div> */}
            </div>

            <Menu closeMenu={() => this.menuToggle()} />

            <Header menuClicked={() => this.menuToggle()} idMenu="siteHeader" />

            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/quem-somos" exact component={QuemSomos} />
              <Route path="/sobre-o-relatorio" exact component={SobreRelatorio} />
              <Route path="/associados" exact component={Associados} />
              <Route path="/sumario-gri" exact component={Sumario} />
              {/* <Route path="/plano-de-acao-2020" exact component={PlanoAcao} /> */}
              <Route path="/plano-de-acao-2019" exact component={PlanoAcao2019} />
              <Redirect exact from="/governanca-corporativa" to="/governanca-corporativa/assembleia-geral" />
              <Route path="/governanca-corporativa/assembleia-geral" exact component={Governanca} />
              <Route path="/governanca-corporativa/diretoria" exact component={Diretoria} />
              <Route path="/governanca-corporativa/conselho-fiscal" exact component={ConselhoFiscal} />
              <Route path="/governanca-corporativa/conselho-de-etica" exact component={ConselhoEtica} />
              <Route
                path="/governanca-corporativa/organismos-de-representacao"
                exact
                component={OrganismosRepresentacao}
              />
              <Route path="/governanca-corporativa/comite-executivo" exact component={ComiteExecutivo} />
              <Route path="/pessoas" exact component={Pessoas} />
              <Route path="/relacionamentos" exact component={Relacionamentos} />
              <Route path="/estrategias/nosso-ano" exact component={NossoAno} />
              <Route path="/estrategias/para-o-mercado" exact component={ParaOMercado} />
              <Route path="/estrategias/dentro-de-casa" exact component={DentroDeCasa} />
              <Route path="/pessoas/organograma" exact component={Organograma} />

              <Route path="/iniciativas/:id" exact component={Iniciativas} />
              <Route path="/iniciativa/agenda-recursos" exact component={AgendaRecursos} />
              <Route path="/iniciativa/cultura-de-dados" exact component={CulturaDeDados} />
              <Route path="/iniciativa/treinamentos" exact component={Treinamentos} />
              <Route path="/iniciativa/data-fundos" exact component={DataFundos} />
              <Route path="/iniciativa/pesquisa-raio-x-do-investidor-brasileiro" exact component={PerfilInvestidor} />
              <Route path="/iniciativa/cursos-educativos" exact component={CursosEducativos} />
              <Route path="/iniciativa/mercado-de-capitais" exact component={MercadoDeCapitais} />
              <Route path="/iniciativa/atuacao-internacional" exact component={AtuacaoInternacional} />
              <Route path="/iniciativa/selic-40-anos" exact component={Selic40Anos} />
              <Route path="/iniciativa/lei-liberdade-economica" exact component={LeiLiberdadeEconomica} />
              <Route path="/iniciativa/supervisao-da-precificacao-de-ativos" exact component={SupervisaoAtivos} />
              <Route path="/iniciativa/certificacao-e-educacao" exact component={CertificacaoEducacao} />
              <Redirect exact from="/mensagens" to="/mensagens/presidencia" />
              <Route path="/mensagens/presidencia" exact component={MensagemPresidencia} />
              <Route path="/mensagens/superintendencia" exact component={MensagemSuperintendencia} />
              <Route
                path="/iniciativa/balanco-das-orientacoes-e-penalidades-da-autorregulacao"
                exact
                component={BalancoOrientacoesPenalidades}
              />
              <Route path="/linha-do-tempo" exact component={LinhaDoTempo} />
              <Route path="/eventos" exact component={Eventos} />
              <Route path="*" component={NotFound} />
            </Switch>

            <Footer clicked={() => this.scrollTop(true)} />
          </div>
        </Analytics>
      </HashRouter>
    );
  };
}
